import { FormGroupState, FormState } from 'ngrx-forms'
import { createSelector } from '@ngrx/store'
import { AccountState, PendingState, selectAccountState } from '../account.root.state'
import { C4PaymentMethodDetail } from '@api/http.service'
import { KeycloakData } from './user-profile.reducers'

export interface ProfileState {
  changeEmailControls: FormGroupState<ChangeEmailValues>
  changePhoneNumberControl: FormState<string>
  changeBirthdateControl: FormState<string>
  changeMobileControl: FormState<string>
  closeAccountControl: FormState<string>
  changeEmailPasswordPromptControl: FormState<string>
  customerInformationState: CustomerInformationState
  changePasswordControls: FormState<ChangePasswordValues>
  forgotPasswordControl: FormState<string>
  paymentMethodsState: C4PaymentMethodDetail[]
  c4sessionId: string
  c4LoginState: PendingState
  paymentMethodsPendingState: PendingState
  keycloakData: KeycloakData
  adrGr: string
  isGroupAdmin?: boolean
}

// export interface PaymentMethodState {
//   c4pk: string
//   paymentType: string
//   paymentMethodActive: boolean
// }

export interface CustomerInformationState {
  firstName: string
  lastName: string
  customerNumber: string
  customerSubNumber: string
  email: string
  phoneNumber: string
  mobile: string
  birthdate: string
  customerSince: string
  address: Address
  uuid: string
}

export interface Address {
  firstName: string
  lastName: string
  street: string
  street2: string
  postalCode: string
  city: string
  company: string
  countryCode: string
}

export interface ChangeEmailValues {
  newMail: string
  repeatMail: string
}

export interface ChangePasswordValues {
  oldPassword: string
  newPassword: string
  repeatPassword: string
}

export const selectProfileState = {
  profileState: createSelector(selectAccountState, (state: AccountState): ProfileState => state.profileState),
  changeEmailControls: createSelector(
    selectAccountState,
    (state: AccountState): FormGroupState<ChangeEmailValues> => state.profileState.changeEmailControls,
  ),
  changeEmailPasswordPromptControl: createSelector(
    selectAccountState,
    (state: AccountState): FormState<string> => state.profileState.changeEmailPasswordPromptControl,
  ),
  changePhoneNumberControls: createSelector(
    selectAccountState,
    (state: AccountState): FormState<string> => state.profileState.changeMobileControl,
  ),
  changeMobileControls: createSelector(
    selectAccountState,
    (state: AccountState): FormState<string> => state.profileState.changePhoneNumberControl,
  ),
  changeBirthdateControls: createSelector(
    selectAccountState,
    (state: AccountState): FormState<string> => state.profileState.changeBirthdateControl,
  ),
  customerInformationState: createSelector(
    selectAccountState,
    (state: AccountState): CustomerInformationState => state.profileState.customerInformationState,
  ),
  customerSubNr: createSelector(
    selectAccountState,
    (state: AccountState): string => state.profileState.customerInformationState.customerSubNumber,
  ),
  customerInfoWithoutAddress: createSelector(
    selectAccountState,
    (state: AccountState): Omit<CustomerInformationState, 'address'> => state.profileState.customerInformationState,
  ),
  customerAddresses: createSelector(
    selectAccountState,
    (state: AccountState): Address => state.profileState.customerInformationState.address,
  ),
  firstNameState: createSelector(
    selectAccountState,
    (state: AccountState): string => state.profileState.customerInformationState.firstName,
  ),
  emailState: createSelector(
    selectAccountState,
    (state: AccountState): string => state.profileState.customerInformationState.email,
  ),
  phoneNumberState: createSelector(
    selectAccountState,
    (state: AccountState): string => state.profileState.customerInformationState.phoneNumber,
  ),
  mobileState: createSelector(
    selectAccountState,
    (state: AccountState): string => state.profileState.customerInformationState.mobile,
  ),
  birthdateState: createSelector(
    selectAccountState,
    (state: AccountState): string => state.profileState.customerInformationState.birthdate,
  ),
  closeAccountState: createSelector(
    selectAccountState,
    (state: AccountState): FormState<string> => state.profileState.closeAccountControl,
  ),
  changePasswordControls: createSelector(
    selectAccountState,
    (state: AccountState): FormState<ChangePasswordValues> => state.profileState.changePasswordControls,
  ),
  forgotPasswordControl: createSelector(
    selectAccountState,
    (state: AccountState): FormState<string> => state.profileState.forgotPasswordControl,
  ),
  paymentMethodsState: createSelector(
    selectAccountState,
    (state: AccountState): C4PaymentMethodDetail[] => state.profileState.paymentMethodsState,
  ),
  paymentMethodsPendingState: createSelector(
    selectAccountState,
    (state: AccountState): PendingState => state.profileState.paymentMethodsPendingState,
  ),
  c4SessionId: createSelector(selectAccountState, (state: AccountState): string => state.profileState.c4sessionId),
  c4LoginState: createSelector(selectAccountState, (state: AccountState): string => state.profileState.c4LoginState),
  keycloakData: createSelector(
    selectAccountState,
    (state: AccountState): KeycloakData => state.profileState.keycloakData,
  ),
  kcUuid: createSelector(selectAccountState, (state: AccountState): string => state.profileState.keycloakData.kcUuid),
  kcEmail: createSelector(selectAccountState, (state: AccountState): string => state.profileState.keycloakData.kcEmail),
  adrGr: createSelector(selectAccountState, (state: AccountState): string => state.profileState.adrGr),
} as const
